import sendRequest from "@/libs/sendRequest"

const commission_settings = {
    namespaced: true,
    state: {
        commission: null,
        service_fee: null,
        error: false
    },
    getters: {
        getCommission: (state) => state.commission,
        getServiceFee: (state) => state.service_fee,
        getError: (state) => state.error
    },
    mutations: {
        setCommission: (state, payload) => state.commission = payload,
        setServiceFee: (state, payload) => state.service_fee = payload,
        setError: (state, payload) => state.error = payload
    },
    actions: {
        get: async({ commit, dispatch, rootGetters }) => {
            dispatch('showLoading', null, { root: true })
            const custom_headers = rootGetters.getHeaders
            const [platformRes, serviceRes] = await Promise.all([
                sendRequest('admin/settings/commission/get', 'GET', null, { key: 'platform_fee' }, custom_headers),
                sendRequest('admin/settings/commission/get', 'GET', null, { key: 'service_fee' }, custom_headers)
            ])

            if(platformRes.success && platformRes.data) {
                commit('setCommission', platformRes.data.commission)
            }
            if(serviceRes.success && serviceRes.data) {
                commit('setServiceFee', serviceRes.data.commission)
            }
            dispatch('hiddenLoading', null, { root: true })

            if(!platformRes.success || !serviceRes.success) {
                dispatch('showError', 'An error has occurred try later', { root: true })
            }
        },
        update: async({ commit, dispatch, rootGetters }, body) => {
            dispatch('showLoading', null, { root: true })
            const custom_headers = rootGetters.getHeaders
            const response = await sendRequest('admin/settings/commission/update', 'PUT', body, null, custom_headers)

            if(response.success && response.data) {
                const label = body.key_name === 'service_fee' ? 'Service fee updated successfully' : 'Platform fee updated successfully'
                dispatch('showAlert', label, { root: true })
                commit('setError', false)
            }
            else if(!response.success && response.errors) {
                commit('setError', true)
                dispatch('hiddenLoading', null, { root: true })
                dispatch('showError', 'An error has occurred try later', { root: true })
            }
        }
    }
}

export default commission_settings
